import { DateField, IAction, IActionPayload, IDisputeLists, IFetchQueueResponse, IState } from './disputes-interfaces';
import { disputesActionTypes } from './disputes-action-types';
import { IDisputeItem } from '../tables/disputes/disputes-data';
import { IDisputeQueueItem } from '../tables/disputes/disputes-queue';
import { MRT_SortingState } from 'material-react-table';
import { initialState } from './disputes-context';

export const disputesReducer = (state: IState, action: IAction): IState => {
    switch (action.type) {
        case disputesActionTypes.FETCH_DISPUTES_SUCCESS: {
            return { ...state, disputes: action.payload as IDisputeItem[], totalItemCount: action.totalItemCount, isDisputesLoading: false };
        }
        case disputesActionTypes.FETCH_DISPUTES_FAIL: {
            return { ...state,
                disputes: state.disputes === null ? [] : state.disputes,
                isDisputesLoading: false,
                isDisputeDetailsLoading: false
            };
        }
        case disputesActionTypes.SET_DISPUTE_DETAILS_LOADING: {
            return { ...state, isDisputeDetailsLoading: action.payload as boolean };
        }
        case disputesActionTypes.FETCH_DISPUTES_DETAILS: {
            return { ...state, disputeDetails: action.payload as IDisputeQueueItem, isDisputeDetailsLoading: false };
        }
        case disputesActionTypes.SET_DISPUTE_DETAILS_TO_DEFAULT: {
            return { ...state, disputeDetails: null, isDisputeDetailsLoading: true };
        }
        case disputesActionTypes.SET_DISPUTES_LOADING: {
            return { ...state, isDisputesLoading: action.payload as boolean };
        }
        case disputesActionTypes.SET_DATETIME: {
            if ((action.payload as IActionPayload)?.field === DateField.requestDate) {
                return { ...state, requestFrom: (action.payload as IActionPayload).requestFrom, requestTo: (action.payload as IActionPayload).requestTo };
            } else if ((action.payload as IActionPayload)?.field === DateField.authorizationDate) {
                return { ...state, from: (action.payload as IActionPayload).from, to: (action.payload as IActionPayload).to };
            } else if ((action.payload as IActionPayload)?.field === DateField.disputeDetailsCreatedDate) {
                return {
                    ...state,
                    disputeDetailsCreatedFrom: (action.payload as IActionPayload).disputeDetailsCreatedFrom,
                    disputeDetailsCreatedTo: (action.payload as IActionPayload).disputeDetailsCreatedTo
                };
            } else {
                return { ...state, createdFrom: (action.payload as IActionPayload).createdFrom, createdTo: (action.payload as IActionPayload).createdTo };
            }
        }
        case disputesActionTypes.SET_DATETIME_ERROR: {
            return { ...state, from: state.from, to: state.to };
        }
        case disputesActionTypes.SET_TIMEZONE: {
            return { ...state, timezone: action.payload as string };
        }
        case disputesActionTypes.SET_TIMEZONE_ERROR: {
            return { ...state, timezone: state.timezone };
        }
        case disputesActionTypes.SET_QUERY_STRING: {
            return { ...state, query: action.payload as string };
        }
        case disputesActionTypes.SET_QUERY_STRING_ERROR: {
            return { ...state, query: state.query };
        }
        case disputesActionTypes.SET_PAGINATION: {
            return {
                ...state,
                pageNumber: (action.payload as IActionPayload).pageNumber,
                pageSize: (action.payload as IActionPayload).pageSize
            };
        }
        case disputesActionTypes.SET_PAGINATION_ERROR: {
            return {
                ...state,
                pageNumber: state.pageNumber,
                pageSize: state.pageSize,
            };
        }
        case disputesActionTypes.SET_SORTING: {
            return { ...state, sorting: action.payload as MRT_SortingState };
        }

        case disputesActionTypes.FETCH_DISPUTES_EXPORT_SUCCESS: {
            return { ...state, isDisputesExportLoading: false };
        }
        case disputesActionTypes.FETCH_DISPUTES_EXPORT_FAIL: {
            return { ...state, isDisputesExportLoading: false };
        }
        case disputesActionTypes.SET_DISPUTES_EXPORT_LOADING: {
            return { ...state, isDisputesExportLoading: action.payload as boolean };
        }
        case disputesActionTypes.SET_DEFAULT_VALUES: {
            return { ...initialState };
        }
        case disputesActionTypes.FETCH_DISPUTES_MANAGEMENT_SYSTEM: {
            return { ...state, managementSystem: action.payload as string[] };
        }
        case disputesActionTypes.FETCH_KOUNT_STATUS_CODES: {
            if (action.payload) {
                return { ...state, kountStatusCodes: action.payload as { [key: string]: string[] } };
            } else {
                return state;
            }
        }
        case disputesActionTypes.FETCH_DISPUTES_CARD_TYPES: {
            return { ...state, cardBrands: action.payload as string[] };
        }
        case disputesActionTypes.SET_DISPUTES_PROVIDER_NAME: {
            return { ...state, selectedProviderName: action.payload as string[] };
        }
        case disputesActionTypes.SET_DISPUTES_CARD_TYPE: {
            return { ...state, selectedCardBrand: action.payload as string[] };
        }
        case disputesActionTypes.SET_DISPUTE_TYPES: {
            return { ...state, selectedDisputeType: action.payload as string[] };
        }
        case disputesActionTypes.SET_IS_WEBHOOK: {
            return { ...state, isWebhook: action.payload as string };
        }
        case disputesActionTypes.SET_IS_FILE_IMPORTED: {
            return { ...state, isFileImported: action.payload as string };
        }
        case disputesActionTypes.SET_IS_MANUAL_INSERTED: {
            return { ...state, isManualInserted: action.payload as string };
        }
        case disputesActionTypes.SET_DISPUTE_MATCH_LOADING: {
            return { ...state, isDisputeMatchLoading: action.payload as boolean };
        }
        case disputesActionTypes.ALERT_KOUNT_LOADING: {
            return { ...state, isKountAlertLoading: action.payload as boolean };
        }
        case disputesActionTypes.SET_ARCHIVATING_DISPUTE_LOADING: {
            return { ...state, isArchivatingDisputeLoading: action.payload as boolean };
        }
        case disputesActionTypes.FETCH_DISPUTE_DETAILS_LISTS: {
            return {
                ...state,
                disputeDetailsLists: action.payload as IDisputeLists
            };
        }
        case disputesActionTypes.SET_DISPUTE_QUEUE_LOADING: {
            return {
                ...state,
                isDisputeQueuesLoading:  action.payload as boolean,
            };
        }
        case disputesActionTypes.FETCH_DISPUTE_QUEUES: {
            return {
                ...state,
                disputeQueues: (action.payload as IFetchQueueResponse)?.disputeQueues?.rows || [],
                isDisputeQueuesLoading: false,
                disputeQueueTotalItemCount: (action.payload as IFetchQueueResponse)?.disputeQueues?.totalItemCount || 0,
            };
        }
        case disputesActionTypes.SET_IS_PROVIDER_NAME: {
            return { ...state, isProviderName: action.payload as boolean };
        }
        case disputesActionTypes.SET_DISPUTES_QUEUE_DATA_TO_DEFAULT: {
            return {
                ...state,
                disputeQueues: [],
                isDisputeQueuesLoading: true,
                disputeQueueTotalItemCount: 0,
            };
        }
        case disputesActionTypes.SET_DISPUTES_QUEUE_ITEMS_LIST_DATA_TO_DEFAULT: {
            return {
                ...state,
                disputes: [],
                pageNumber: 0,
                pageSize: 10
            };
        }
        case disputesActionTypes.CLEAR_FILTER: {
            return {
                ...state,
                query: '',
                isWebhook: '',
                isFileImported: '',
                isManualInserted: '',
                from: null,
                to: null,
                createdFrom: null,
                createdTo: null,
                requestFrom: null,
                requestTo: null,
                selectedCardBrand: [],
                selectedDisputeType: [],
                selectedProviderName: [],
                timezone: 'UTC',

                disputeQueueTotalItemCount: 0,
                disputeQueueTimezone: 'UTC',
            };
        }
        case disputesActionTypes.FETCH_REPORT_PROVIDERS_LIST: {
            return { ...state, reportProvidersList: action.payload, isReportProviderListLoading: false };
        }
        case disputesActionTypes.SET_REPORT_PROVIDERS_LIST_LOADING: {
            return { ...state, isReportProviderListLoading: action.payload as boolean };
        }
        default: {
            return state;
        }
    }
};
